export default __webpack_public_path__ + "static/media/pro_aim_graphics.11c628bc.png";